export var getStyles = function (props) {
    var theme = props.theme;
    return {
        contextMenuContainer: {
            position: 'absolute',
            right: '3px',
            top: '3px'
        },
        contextButton: [
            'contextButton',
            {
                opacity: 0,
                color: theme.palette.neutralPrimary
            }
        ]
    };
};
//# sourceMappingURL=NotificationAction.styles.js.map